<template>
  <div class='login-container'>
    <div class='login-content'>
      <div class='title-container'>
        <img :src='logo' />
      </div>
      <el-tabs v-model='type'>
        <el-tab-pane label='密码登录' name='1'>
          <el-form
            ref='loginForm'
            :model='loginForm'
            :rules='loginRules'
            class='login-form'
            autocomplete='on'
            label-position='left'
          >
            <el-form-item prop='username'>
              <el-input
                ref='username'
                v-model.trim='loginForm.username'
                placeholder='用户名'
                name='username'
                type='text'
                tabindex='1'
                autocomplete='on'
              >
                <template slot='prepend'>
                  <!-- <svg-icon icon-class="user" /> -->
                  用户名
                </template>
              </el-input>
            </el-form-item>

            <el-tooltip v-model='capsTooltip' content='大写锁定已开启' placement='right' manual>
              <el-form-item prop='password'>
                <el-input
                  :key='passwordType'
                  ref='password'
                  v-model.trim='loginForm.password'
                  :type='passwordType'
                  placeholder='用户密码'
                  name='password'
                  tabindex='2'
                  autocomplete='on'
                  @keyup.native='checkCapslock'
                  @blur='capsTooltip = false'
                >
                  <template slot='prepend'>
                    <!-- <svg-icon icon-class="password" /> -->
                    密&#12288;码
                  </template>
                </el-input>
                <span class='show-pwd' @click='showPwd'>
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
              </el-form-item>
            </el-tooltip>
            <el-form-item prop='captcha' class='m-b-15 input-flex-append'>
              <el-input
                ref='captcha'
                tabindex='3'
                placeholder='图形验证码'
                v-model='loginForm.captcha'
                @keyup.enter.native='handleLogin'
              >
                <template slot='prepend'>验证码</template>
              </el-input>
              <img
                :src='`${baseUrl}/captcha?t=${captchaTime}`'
                alt='验证码'
                width='120px'
                style='vertical-align: middle;cursor: pointer'
                @click='refreshTime'
              />
            </el-form-item>
            <router-link to='/resetPassword' class='reset'>忘记密码？</router-link>
            <el-form-item class='m-t-15'>
              <el-button
                :loading='loading'
                class='width-full'
                tabindex='4'
                type='primary'
                @click.native.prevent='handleLogin'
              >登录
              </el-button>
            </el-form-item>
          </el-form>

        </el-tab-pane>
        <el-tab-pane label='短信验证码登录' name='2'>
          <el-form
            ref='smsCodeForm'
            :model='smsCodeForm'
            :rules='smsCodeRules'
            class='login-form'
            autocomplete='on'
            label-position='left'
          >
            <el-form-item prop='phone'>
              <el-input
                v-model.trim='smsCodeForm.phone'
                placeholder='手机号'
                type='tel'
                tabindex='1'
              >
                <template slot='prepend'>
                  手机号
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop='captcha' class='input-flex-append'>
              <el-input
                ref='smsCaptcha'
                placeholder='图形验证码'
                v-model.trim='smsCodeForm.captcha'
                tabindex='2'
              >
                <template slot='prepend'>图形码</template>
              </el-input>
              <img
                :src='`${ssoBaseUrl}/captcha?t=${ssoCaptchaTime}`'
                alt='验证码'
                width='120px'
                style='vertical-align: middle;cursor: pointer'
                @click='ssoCaptchaTime = new Date().getTime()'
              />
            </el-form-item>
            <el-form-item prop='smsCode' class='m-b-15 input-flex-append'>
              <el-input
                v-model.trim='smsCodeForm.smsCode'
                placeholder='短信验证码'
                @keyup.enter.native='handleLogin'
                tabindex='3'
              >
                <template slot='prepend'>
                  <!-- <svg-icon icon-class="password" /> -->
                  验证码
                </template>
              </el-input>
              <el-button type='primary' style='height: 47px;padding: 10px 25px;width: 123px' :disabled='disabled' @click='startCountdown'>
                {{ countdown > 0 ? `${ countdown }s` : '获取验证码' }}
              </el-button>
            </el-form-item>
            <div class='reset' style='visibility: hidden'>1</div>
            <el-form-item class='m-t-15'>
              <el-button
                :loading='loading'
                class='width-full'
                tabindex='4'
                type='primary'
                @click.native.prevent='handleSmsCodeLogin'
              >登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  Form, FormItem, Tooltip, Input, Tabs, TabPane
} from 'element-ui';
import { validUsername } from '@/utils/validate';
import { login, fetchGetSmsCode, fetchSmsCodeLogin, fetchSmsCodeLoginTicket, logger } from '@/api';
import pattern from '@/utils/pattern';
import env from '@/api/env';
import fetchCode from '@/utils/fetchCode';
import utils from '@/utils';
import LOGO from '../assets/images/logo.png';

export default {
  name: 'Login',
  components: {
    ElTooltip: Tooltip,
    ElForm: Form,
    ElInput: Input,
    ElFormItem: FormItem,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('请输入正确的用户名'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入正确的用户密码'));
      } else {
        callback();
      }
    };
    return {
      timer: null, // 计时器
      timeOut: false, // 登录是否正在进行中
      type: '1',
      countdown: 0,
      disabled: false,
      baseUrl: env.baseUrl,
      ssoBaseUrl: env.ssoBaseUrl,
      smsCodeCaptcha: '',
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        remember_me: false
      },
      smsCodeForm: {
        phone: '',
        captcha: '',
        smsCode: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [
          {
            required: true,
            message: '请填写正确的验证码',
            trigger: 'blur',
            pattern: pattern.captcha
          }
        ]
      },
      smsCodeRules: {
        phone: [
          {
            required: true,
            message: '请填写正确的手机号码',
            trigger: 'blur',
            pattern: pattern.phone
          }
        ],
        captcha: [
          {
            required: true,
            message: '图形验证码错误',
            trigger: 'blur',
            pattern: pattern.captcha
          }
        ],
        smsCode: [
          {
            required: true,
            message: '短信验证码错误',
            trigger: 'blur',
            pattern: pattern.smsCode
          }
        ]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      logo: LOGO,
      captchaTime: new Date().getTime(),
      ssoCaptchaTime: new Date().getTime()
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  mounted() {
    localStorage.removeItem('token');
    localStorage.removeItem('clientId');
    // 页面加载完成后，开始计时
    this.timer = setTimeout(() => {
      this.timeOut = true;
    }, 10 * 60 * 1000); // 10分钟，单位是毫秒
    if (this.isRest) return;
    if (this.loginForm.username === '') {
      this.$refs.username.focus();
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus();
    }
  },
  methods: {
    removeCookie() {
      document.cookie = '_cke=;Domain=ccc-api-qa.dev-test.dragonest.com;Path=/';
    },
    /*
    getSmsCode() {
      const cookieVal = localStorage.getItem('cookie');
      axios.get('//ccc-sso-qa.dev-test.mmxlr.com/api/captcha', {
        withCredentials: true,
        responseType: 'arraybuffer',
        header: {
          cookie: cookieVal
        }
      })
        .then(response => {
          console.log(11111, document.cookie);
          console.log(4444, response.headers);
          // cookie提取
          const cookie = response.headers['Set-Cookie'] || response.headers['set-cookie'];
          console.log(2333333, cookie);
          getCookie(cookie);
          const imageData = Buffer.from(response.data, 'binary').toString('base64');
          const imageUrl = `data:image/jpeg;base64,${imageData}`;
          const imgElement = document.getElementById('smsCode');
          imgElement.src = imageUrl;
        })
        .catch(error => {
          console.error(error);
        });
    }, */
    async startCountdown() {
      if (!this.smsCodeForm.phone) {
        this.$message.error('请输入手机号');
        return;
      }
      if (!this.smsCodeForm.captcha) {
        this.$message.error('请输入图形验证码');
        return;
      }
      // 禁用按钮，避免连续点击
      this.disabled = true;
      // 发送验证码请求的逻辑，可以根据自己的需求实现
      const params = {
        phone: this.smsCodeForm.phone,
        verify_code: this.smsCodeForm.captcha,
        type: 'login'
      };
      const res = await fetchGetSmsCode(params);
      if (res.code === 200) {
        this.$message.success('发送成功');
        this.countdown = 60;
        this.timer = setInterval(this.updateCountdown, 1000);
      } else {
        this.disabled = false;
        this.$message.error(res.message);
      }
    },
    updateCountdown() {
      if (this.countdown > 0) {
        this.countdown -= 1;
      } else {
        // 倒计时结束，恢复按钮状态
        clearInterval(this.timer);
        this.disabled = false;
      }
    },
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if ((shiftKey && (key >= 'a' && key <= 'z')) || (!shiftKey && (key >= 'A' && key <= 'Z'))) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      if (this.timeOut) {
        this.$message.error('登录超时，请刷新页面重新登录！');
        return;
      }
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          login({
            ...this.loginForm,
            remember_me: true
          })
            .then(({ data }) => {
              localStorage.removeItem('token');
              localStorage.removeItem('clientId');
              this.setLoginInfo(data, 1);
            })
            .catch(e => {
              this.loading = false;
              if (e && e.data && (e.data.error_code === fetchCode.CAPTCHA_ERROR || e.data.error_code === fetchCode.TIMER_OUT)) {
                this.refreshTime();
                this.loginForm.captcha = '';
                this.$refs.captcha.focus();
              }
            });
          return true;
        }
        return false;
      });
    },
    async handleSmsCodeLogin() {
      if (this.timeOut) {
        this.$message.error('登录超时，请刷新页面重新登录！');
        return;
      }
      const valid = await this.$refs.smsCodeForm.validate();
      if (!valid) return;
      try {
        this.loading = true;
        const params = {
          phone: this.smsCodeForm.phone,
          captcha_code: this.smsCodeForm.smsCode,
          type: 'adminPhone'
        };
        const loginRes = await fetchSmsCodeLogin(params);
        if (loginRes.code !== 200) {
          this.$message.error(loginRes.message);
          return;
        }
        const { ticket } = loginRes.data;
        const stRes = await fetchSmsCodeLoginTicket({
          st: ticket,
          is_small_app: true
        });
        if (stRes.error_code === 999999) {
          const { access_token, client_id } = stRes.data;
          localStorage.setItem('token', access_token);
          localStorage.setItem('clientId', client_id);
          this.setLoginInfo(stRes.data, 2);
        }
      } catch (e) {
        this.ssoCaptchaTime = new Date().getTime();
        this.smsCodeForm.captcha = '';
        this.$refs.smsCaptcha.focus();
      } finally {
        this.loading = false;
      }
    },
    setLoginInfo(data, type) {
      if (data.access_token) {
        this.$store.dispatch('user/setAuth', data).then(() => {
          if (type === 1) {
            logger.fetchLoggerPost({
              module: 1,
              event_type: 1,
              cusp: '使用账号密码登录',
              status: 1
            });
          }
          if (type === 2) {
            logger.fetchLoggerPost({
              module: 1,
              event_type: 15,
              cusp: '使用短信验证码登录',
              status: 1
            });
          }
          this.timeOut = false;
          this.$store.dispatch('msg/showMsg', data.msg || '登录成功');
          this.$store.dispatch('app/changeSys', utils.SYS_KEYS[0]);
          this.$router.push(`/${this.$store.state.user.info.id}`);
        });
      } else {
        this.$store.dispatch('msg/showErrorMsg', data.msg || '登录失败');
      }
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    refreshTime() {
      this.captchaTime = new Date().getTime();
    }
  },
  beforeDestroy() {
    // 组件销毁前，清除计时器
    clearTimeout(this.timer);
  }
};
</script>

<style lang='less'>
/* 修复input 背景不协调 和光标变色 */

@bg: #283443;
@light_gray: #fff;
@cursor: #fff;

/* reset element-ui css */
.login-container {
  height: 100vh;

  .el-tabs__item {
    font-size: 16px;
  }

  &::after {
    content: '';
    min-height: inherit;
    font-size: 0;
  }

  .reset {
    color: @main-blue;
    font-size: 14px;
  }

  .input-flex-append .el-form-item__content {
    > .el-input-group {
      width: 320px;
      margin-right: 5px;
    }

    img {
      width: 120px;
      height: 47px;
    }
  }

  .el-input {
    display: inline-table;
    height: 47px;

    input {
      background: transparent;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      height: 47px;
      line-height: normal;
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }
}

.login-container {
  .el-tabs__nav-wrap::after {
    background: none;
  }
}
</style>

<style lang='less' scoped>
@bg: #2d3a4b;
@dark_gray: #889aa4;
@light_gray: #eee;

.login-container {
  min-height: 100vh;
  width: 100%;
  background: @bg url(../assets/images/login_bg.jpg) no-repeat center;
  background-size: cover;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-content {
    width: 520px;
    padding: 0 35px;
    overflow: hidden;
    background: #fff;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 0 5px 0 15px;
    color: @dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    text-align: center;
    background-color: @main-blue;
    padding: 10px 0;
    margin: 20px 0 10px 0;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: @dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
